import { AppConfig } from "AppConfig";
import { getRequestHeaders } from "msal/MsalAuthProvider";
import { getRequestId } from "../../services/extract/requestContext";

export const margeDocumentsRequest = (model, callback) => {
  const url = `${AppConfig.SERVICE_BASE_URL}/api/v1/extract`;
  const body = JSON.stringify(model);

  fetch(url, {
    method: "POST",
    body: body,
    headers: getRequestHeaders(),
  })
    .then((response) => {
      if (response.status === 400) {
        response.text().then((errorMessage) => {
          callback(false, errorMessage);
          createLog(
            "Error",
            `Create Extract Status:${
              response.status
            }, Error text: ${JSON.stringify(errorMessage)}`,
            url,
            body,
          );
        });
        return;
      } else if (response.status > 400) {
        callback(false, null);
        createLog(
          "Error",
          `Create Extract Status:${response.status}`,
          url,
          body,
        );
        return;
      }

      response.text().then((requestId) => {
        callback(true, requestId.replaceAll('"', ""));
        createLog(
          "Information",
          `Create Extract started successfully, RequestId: ${requestId}`,
        );
      });
    })
    .catch((error) => {
      callback(false, null);
      createLog("Error", `Create Extract : ${error}`, url, body);
    });
};

export const mergeProgressRequest = (requestId, callback) => {
  const url = `${AppConfig.SERVICE_BASE_URL}/api/v1/extract/progress/${requestId}`;

  fetch(url, {
    method: "GET",
    headers: getRequestHeaders(),
  })
    .then((response) => {
      if (response.status === 400) {
        response.text().then((errorMessage) => {
          callback(false, errorMessage);
          createLog(
            "Error",
            `Create Extract Status:${
              response.status
            }, Error text: ${JSON.stringify(errorMessage)}`,
          );
        });
        return;
      } else if (response.status > 400) {
        callback(false, null);
        createLog("Error", `Create Extract Status:${response.status}`);
        return;
      }

      response.json().then((json) => {
        callback(true, json);
        createLog(
          "Information",
          `Create Extract progress received, Response: ${JSON.stringify(json)}`,
        );
      });
    })
    .catch((error) => {
      callback(false, null);
      createLog("Error", `Create Extract : ${error}`);
    });
};

export const getHeadersRequest = (courtType, callback) => {
  const url = `${AppConfig.SERVICE_BASE_URL}/api/v1/extract/${courtType}/headers`;

  fetch(url, {
    method: "GET",
    headers: getRequestHeaders(),
  })
    .then((response) => response.json())
    .then((response) => {
      callback(true, response);
    })
    .catch((error) => {
      alert(`${error} getHeadersRequest`);
      callback(false, null);
      createLog("Error", `Get Headers : ${error}`);
    });
};

export const validateLogoRequest = (imageContent, callback) => {
  const url = `${AppConfig.SERVICE_BASE_URL}/api/v1/extract/validate-logo`;
  const body = JSON.stringify({ content: imageContent });

  fetch(url, {
    method: "POST",
    body: body,
    headers: getRequestHeaders(),
  })
    .then((response) => {
      if (response.status === 400) {
        response.text().then((errorMessage) => {
          callback(false, errorMessage);
          createLog(
            "Error",
            `Validate Logo Status:${
              response.status
            }, Error text: ${JSON.stringify(errorMessage)}`,
            url,
            body,
          );
        });
        return;
      } else if (response.status > 400) {
        callback(false, null);
        createLog(
          "Error",
          `Validate Logo Status:${response.status}`,
          url,
          body,
        );
        return;
      }

      callback(true, null);
    })
    .catch((error) => {
      callback(false, null);
      createLog("Error", `Validate Logo : ${error}`, url, body);
    });
};

export const validatePdfFileRequest = (
  validateHeaders,
  fileName,
  blob,
  callback,
) => {
  const defaultHeaders = getRequestHeaders();
  let validateRequestHeaders = validateHeaders;
  if (
    defaultHeaders["Authorization"] &&
    !validateRequestHeaders["Authorization"]
  ) {
    validateRequestHeaders["Authorization"] = defaultHeaders["Authorization"];
  }

  const url = `${AppConfig.SERVICE_BASE_URL}/api/v1/extract/validate`;
  const body = JSON.stringify({ name: fileName });

  fetch(url, {
    method: "POST",
    body: blob,
    headers: validateRequestHeaders,
  })
    .then((response) => {
      if (response.status === 400) {
        response.text().then((errorMessage) => {
          callback(false, errorMessage);
          createLog(
            "Error",
            `Validate PDF File Status :${
              response.status
            }, Error text: ${JSON.stringify(errorMessage)}`,
            url,
            body,
          );
        });

        return;
      } else if (response.status > 400) {
        callback(false, null);
        createLog(
          "Error",
          `Validate PDF File Status :${response.status}`,
          url,
          body,
        );
        return;
      } else if (response.status === 202) {
        response.json().then((json) => {
          json.isUploaded = false;
          callback(true, json);
        });
      } else if (response.status === 200) {
        response.json().then((json) => {
          json.isUploaded = true;
          callback(true, json);
        });
      }
    })
    .catch((error) => {
      callback(false, null);
      createLog("Error", `Validate PDF File : ${error}`, url, body);
    });
};

export const extractDataFromPDFRequest = (
  fileName,
  blob,
  uploadHeaders,
  callback,
) => {
  const defaultHeaders = getRequestHeaders();
  let uploadRequestHeaders = uploadHeaders;
  if (
    defaultHeaders["Authorization"] &&
    !uploadRequestHeaders["Authorization"]
  ) {
    uploadRequestHeaders["Authorization"] = defaultHeaders["Authorization"];
  }

  const url = `${AppConfig.SERVICE_BASE_URL}/api/v1/extract/extract`;
  const body = JSON.stringify({ name: fileName });

  fetch(url, {
    method: "POST",
    body: blob,
    headers: uploadRequestHeaders,
  })
    .then((response) => {
      if (response.status === 400) {
        response.text().then((errorMessage) => {
          callback(false, errorMessage);
          createLog(
            "Error",
            `Extract Data From PDF Status :${
              response.status
            }, Error text: ${JSON.stringify(errorMessage)}`,
            url,
            body,
          );
        });
        return;
      } else if (response.status > 400) {
        callback(false, null);
        createLog(
          "Error",
          `Extract Data From PDF Status :${response.status}`,
          url,
          body,
        );
        return;
      } else if (response.status === 202) {
        response.json().then((json) => {
          callback(true, json);
        });
      } else if (response.status === 200) {
        response.json().then((json) => {
          callback(true, json);
        });
      }
    })
    .catch((error) => {
      callback(false, null);
      createLog("Error", `Extract Data From PDF : ${error}`, url, body);
    });
};

export const editExtractedFileRequest = (model, callback) => {
  const url = `${AppConfig.SERVICE_BASE_URL}/api/v1/extract`;
  const body = JSON.stringify(model);

  fetch(url, {
    method: "PUT",
    body: body,
    headers: getRequestHeaders(),
  })
    .then((response) => {
      if (response.status === 400) {
        response.text().then((errorMessage) => {
          callback(false, errorMessage);
          createLog(
            "Error",
            `Edit Extracted File Status :${
              response.status
            }, Error text: ${JSON.stringify(errorMessage)}`,
            url,
            body,
          );
        });
        return;
      } else if (response.status > 400) {
        callback(false, null);
        createLog(
          "Error",
          `Edit Extracted File Status :${response.status}`,
          url,
          body,
        );
        return;
      }

      response.json().then((json) => {
        createLog(
          "Information",
          `Document edited successfully, Response: ${json}`,
        );
        callback(true, json);
      });
    })
    .catch((error) => {
      callback(false, null);
      createLog("Error", `Edit Extracted File: ${error}`, url, body);
    });
};

export const getLogoPositionsRequest = (callback, attempt = 0) => {
  const url = `${AppConfig.SERVICE_BASE_URL}/api/v1/extract/logo-position?language=da`;

  fetch(url, {
    method: "GET",
    headers: getRequestHeaders(),
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status >= 400) {
        callback(false, null);
        createLog("Error", `Get Logo Positions Status :${response.status}`);
        return;
      }
      callback(true, response);
    })
    .catch((error) => {
      // This fires unconditionally the instant the user enters the extract screen, which is
      // also the coldest moment for the browser's network stack (tab just resumed, Wi-Fi just
      // reassociated) -- a single retry absorbs most of that transient class of failure.
      if (attempt < 1) {
        setTimeout(() => getLogoPositionsRequest(callback, attempt + 1), 1000);
        return;
      }
      callback(false, null);
      createLog("Error", `Get Logo Positions: ${error}`);
    });
};

export const validateExtractTypeDemo = (extractType, callback) => {
  const url = `${AppConfig.SERVICE_BASE_URL}/api/v1/extract/${extractType}/demo/exists`;

  fetch(url, {
    method: "GET",
    headers: getRequestHeaders(),
  })
    .then((response) => {
      if (response.status >= 400) {
        callback(false, null);
        createLog("Error", `Validate Extract Type Demo :${response.status}`);
        return;
      }
      callback(true, response);
    })
    .catch((error) => {
      callback(false, null);
      createLog("Error", `Validate Extract Type Demo: ${error}`);
    });
};

export const getExtractTypeDemo = (extractType, callback) => {
  const url = `${AppConfig.SERVICE_BASE_URL}/api/v1/extract/${extractType}/demo/init`;

  fetch(url, {
    method: "POST",
    headers: getRequestHeaders(),
  })
    .then((response) => response.json())
    .then((response) => {
      if (response.status >= 400) {
        callback(false, null);
        createLog("Error", `Get Extract Type Demo :${response.status}`);
        return;
      }
      callback(true, response);
    })
    .catch((error) => {
      callback(false, null);
      createLog("Error", `Get Extract Type Demo: ${error}`);
    });
};

export const createLog = (level, message, url, body = null) => {
  const requestId = getRequestId();
  createLogRequest({ level, message, requestId, url, body });
};

export const createLogRequest = (logModel) => {
  const url = `${AppConfig.SERVICE_BASE_URL}/api/v1/extract/log`;

  fetch(url, {
    method: "POST",
    headers: getRequestHeaders(),
    body: JSON.stringify(logModel),
  }).catch(() => {});
};
